import React from 'react';
import './blog-post.css';


//import reportWebVitals from './reportWebVitals';

const ComAppAnnounce = () => {

  return (
    <div>
      <div className='blog__container'>
        <div className="row">
            <div className="column">
                <header>
                    <h3 className="site-post-title rounded title-padding">
                        <b>WiC at Work</b>
                    </h3>
                </header>
                <section>
                    <h2>Committee Applications Released</h2>
                    <p className="site-post-meta">October 1, 2022</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                        Looking for a great way to get involved in the Allen School and meet new people?
                        Interested in building community and promoting inclusion in computing? Apply to
                        join a WiC committee today!
                    </p>
                    <p>
                        Women in Computing (WiC) @ UW is an Allen School student group dedicated to supporting
                        women in the Allen School and promoting inclusion in computing. As a committee member,
                        you would help plan fun events for WiC members on the Social Events committee, expand
                        WiC’s social media presence on the Social Media Committee, or plan workshops for K-12
                        students on the Outreach Committee!
                    </p>
                    <p>
                        Please review the responsibilities for the Social Events committee, Social Media committee,
                        and Outreach committee here: <a href="https://tinyurl.com/wic-committees-22">https://tinyurl.com/wic-committees-22</a>
                    </p>
                    <p>
                        Apply here: <a href="https://tinyurl.com/wic-committee-app-22">:https://tinyurl.com/wic-committee-app-22</a>
                    </p>
                    <p>
                        Applications will open on FRIDAY, SEPTEMBER 30TH and close WEDNESDAY, OCTOBER 19TH at 11:59
                        PM PDT and you may only apply to one committee.
                    </p>
                    <p>
                        If you have any more questions about what it means to be a committee member, feel free to
                        reach out to us at wic-officers@cs.washington.edu!
                    </p>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default ComAppAnnounce;